import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {ApiService} from '../api.service';
import {CommonService} from '../common.service';
import {ActivatedRoute, Router} from '@angular/router';

declare var $: any;
declare var Hammer:any;
declare var echarts:any;

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css', ]
})
export class ReportComponent implements OnInit, AfterViewInit {
  @Input() isOnlyLearningPathCannotBack: boolean;
  @Input() surveyId: number;
  report: any;
  step: number;
  smallBallArray: any;
  currentAbility: any;
  learningTour: boolean;
  learningPathMetaId: number;
  learningPath: any;
  firstFlag: boolean;//是否第一次昨晚DNA检测
  audio: any;//音频
  chartData: any; //图表数据
  chartsOpt: any; //图表配置
  abilityBack:boolean;
  //滑动对象
  hammertime:any;
  isOpenClass: number = 0;
  assetsRoute: string = "../../assets";
  assetsRouteUrl: string;
  isShowBackBtn : boolean = true
  isHarmonyOS: boolean = false;
  constructor(private apiService: ApiService,
              private router: Router,
              private route: ActivatedRoute,
              private commonService:CommonService){}

  ngOnInit() {
      this.isHarmonyOS = this.commonService.isHarmonyOS();
      this.isShowBackBtn = localStorage.getItem("source_env") == "LMS_SCORM" ? false : true;
      this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
      this.apiService.ajax({
        'type':'GET',
        'url': 'sr/exposeoutapi/getAbilityBack'
      }).subscribe(result=>{
        this.abilityBack = result.data.abilityBack;
      });
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.assetsRouteUrl = this.assetsRoute + '/picture/feature/sorry.svg';
      this.getReport();
      this.getApiData();
      // $(document).ready(function(){
      //   var o = document.getElementById("div1");
      //   o.addEventListener("webkitAnimationEnd", function () {
      //     this.parentNode.className = "none";
      //   });
      // });

    /*this.report = this.getMockData().details;
    this.currentAbility = this.report[4];
    this.setsmallBallArray(this.currentAbility.ability_id);*/

    this.step = 1;
    this.apiService.ajax({
      'type':'get',
      'url': '/sr/learningtour',
    }).subscribe(result => {
      this.learningTour = result.pre_survey_meta_ids.length > 0;
    });
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      'backgroundColor':'#3f4c84'
    });

    let that = this;
    setTimeout(()=>{
      let num = $('#animationBallWrap').length;
      if(num!=0){
        this.hammertime = new Hammer(document.getElementById('animationBallWrap'));
        this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
        this.hammertime.on('swipeup swipedown', function(ev){
          that.logEventType(ev,that);
        });
      }
    },1000);


    if(!that.firstFlag){
      setTimeout(()=>{
        $('#normalBallWrap').show();
      },1000);
    }
  }

  logEventType(ev,that){
    if(ev.type == "swipeup"){
      $('#firstReportView').css({
        'top': '-100%',
        'opacity':'0'
      });
      that.hammertime.get('swipe').set({  enable: false  });

      let len = ($('.radio').length);
      for(let i = 0; i<len;i+=1){
        $('#rad'+i).removeClass('mymove'+i).addClass('afterMove'+i).text(this.report[i].norm_point);
      }

      if(this.firstFlag){
        let cid = 0, type = 14;
        this.apiService.ajax({
          'type': 'GET',
          'url': '/sr/incentiveLine/firstHintsGetTreasure/'+cid+'/'+type+'/1',
          'data': {}
        }).subscribe(result=>{});
      }


      setTimeout(()=>{
        $('#firstReportView').hide();
        // $('.coverWrap').hide();
      },500);

      setTimeout(()=>{
        $('.animationAfterTxt').fadeIn(200);
        $('#normalBallWrap2').show();
        $('#animationBallWrap').hide();
        // $('.animationAfterAudio').addClass('animationAfterFadeIn');
      },1600);
    }
  }

  smallBallClick(i){
    let that=this;
    $('#bigBall').fadeOut(200);
    setTimeout(function () {
      that.currentAbility = that.smallBallArray[i];
      that.setsmallBallArray(that.currentAbility.ability_id);
      // $('#topBar').css({'width':0});
      $(".description").scrollTop(0);
      $('#bigBall').fadeIn(200);
    },200);
    setTimeout(function () {
      $('#topBar'+i).css({'left':this.report[i].norm_point * 0.92 + '%'});
      $('#arrowBom'+i).css({'left':this.report[i].norm_point * 0.92 + 1.5 + '%'});
    },400);
      $('#lowContent').scrollTop(0);
      $('#highContent').scrollTop(0);
  }

  setsmallBallArray(abilityId){
    this.smallBallArray = [];
    let that=this;
    this.report.forEach(function (item,index) {
      if(item.ability_id!=abilityId){
         that.smallBallArray.push(item);
      }
    });
    this.smallBallArray = this.shuffle(this.smallBallArray);
    // $('#topBar').css({'width':that.currentAbility.norm_point/100});
  }




  getApiData(){
    let cid = 0, type = 14;
    this.apiService.ajax({
      'type': 'GET',
      'url': '/sr/incentiveLine/firstHintsGetTreasure/'+cid+'/'+type+'/0',
      'data': {}
    }).subscribe(result=>{
        this.firstFlag = result.firstFlag;
        // this.firstFlag = true;
    });

    this.apiService.ajax({
      'type': 'GET',
      'url': '/sr/coursedna/queryCourseDNAList',
      'data': {}
    }).subscribe(result=>{
        for(let i = 0, len = result.length;i<len;i+=1 ){
            result[i].totalTime = this.getTimeformat(result[i].totalTime);
        }
        this.audio = result;
    });

  }

  getReport() {
    this.apiService.getDNAReport("" + this.surveyId + "").subscribe(report => {
      this.report = report.details;
    });
  }

  creatChart(index,flag){
      let charts;
      if(flag){
        charts = echarts.init(document.getElementById('detailReportChart'+index));
      }else{
        charts = echarts.init(document.getElementById('firstReportChart'+index));
      }


      let colorObj = {
        "0": ['rgb(152,162,233)','rgb(234,234,234)'],
        "1": ['rgb(146,127,215)','rgb(234,234,234)'],
        "2": ['rgb(206,143,203)','rgb(234,234,234)'],
        "3": ['rgb(105,122,230)','rgb(234,234,234)'],
        "4": ['rgb(99,151,203)','rgb(234,234,234)'],
        };


      this.chartData = [
        {value:this.report[index].norm_point, name:'得分'},
        {value:100 -this.report[index].norm_point, name:'总分'},
      ];

       this.chartsOpt = {
      tooltip : {
        show:false,
      },
      legend: {
        show: false,
      },
      toolbox: {
        show : false,
      },


      calculable : true,
      color: colorObj[index],
      series : [
        {
          name:'DNA检测',
          type:'pie',
          radius : ['91%', '100%'],
          hoverAnimation: false,
          // startAngle: 275,
          // radius : ['25rem', '30rem'],
          itemStyle : {
            normal : {
              label : {
                show : false
              },
              labelLine : {
                show : false
              }
            }
          },
          data:this.chartData
        }
      ],
    };
      charts.setOption(this.chartsOpt);
  }

  linkToAudio(i){
    this.route.params.subscribe(params => {
      let learningPathOrLearningTourId = params['learningPathOrLearningTourId'];
      let surveyMetaId = params['surveyMetaId'];
      let method = params['method'];
      let link = ['audioPlay',learningPathOrLearningTourId,surveyMetaId,this.surveyId,method,i];
      this.router.navigate(link);
    });
  }

  showReport(i){
    $('#detailReport'+i).show().addClass('scaleAll'+i).addClass('index300');
    setTimeout(()=>{
      $('#container'+i).addClass('scaleOut');
      // $('#topBar'+i).css({'width':0});
      setTimeout(()=>{
        // this.creatChart(i,true);
        $('#topBar'+i).css({'left':this.report[i].norm_point * 0.92 + '%'});
        $('#arrowBom'+i).css({'left':this.report[i].norm_point * 0.92 + 1.5 + '%'});
        $('#exitBtn'+i).show();
      },250);
    },650);
  }

  firstShowReport(i){
    console.log(this.report[i].norm_point);
    $('#normalBallWrap3').find('#detailReport'+i).show().addClass('firstScale').addClass('index300');
    setTimeout(()=>{
      $('#normalBallWrap3').find('#container'+i).addClass('scaleOut');
      // $('#normalBallWrap3').find('#topBar'+i).css({'width':0});
      setTimeout(()=>{
        // this.creatChart(i,false);
        // $('#normalBallWrap3').find('#topBar'+i).animate({'width':this.report[i].norm_point+'%'});
        $('#normalBallWrap3').find('#topBar'+i).css({'left':this.report[i].norm_point * 0.92 + '%'});
        $('#normalBallWrap3').find('#arrowBom'+i).css({'left':this.report[i].norm_point * 0.92 + 1.5 + '%'});
        $('#normalBallWrap3').find('#exitBtn'+i).show();
      },250);
    },200);
  }

  getTimeformat(timeSeconds) {
    var theTime = timeSeconds; // 秒
    var theTime1 = 0; // 分
    var theTime2 = 0; // 小时
    if (theTime > 60) {
      theTime1 = Math.floor(theTime / 60);
      theTime = Math.floor(theTime % 60);
      if (theTime1 > 60) {
        theTime2 = Math.floor(theTime1 / 60);
        theTime1 = Math.floor(theTime1 % 60);
      }
    }
    var result = "" + Math.floor(theTime);
    if (theTime < 10) {
      result = "0" + result;
    }
    if (theTime1 > 0) {
      result = "" + Math.floor(theTime1) + "'" + result;
    } else {
      result = "0:" + result;
    }
    if (theTime2 > 0) {
      result = "" + Math.floor(theTime2) + "'" + result;
    }
    return result;
  }

  onRadioClick(index){
    let that=this;
    this.currentAbility = this.report[index];
    this.setsmallBallArray(this.currentAbility.ability_id);
    this.step = 2;
    if(this.learningTour){
        $('#backButton').css({'top':'12.1rem'});
    }
    setTimeout(function () {
        $('#topBar').animate({'width':that.currentAbility.norm_point+'%'});
    },200);
  }

  shuffle(array){
    let tmp, current, top =array.length;
    if(top) while(--top){
      current =Math.floor(Math.random() * (top + 1));
      tmp =array[current];
      array[current] =array[top];
      array[top] = tmp;
    }
    return array;
  }


  openTip() {
    $("#shade").fadeIn(500);
    $("#closeBtn").fadeIn(500);
    $("#exception_clause").fadeIn(500);
    //document.getElementById("list_wrap").ontouchmove=function(e){e.preventDefault();}
    document.getElementById("shade").ontouchmove = function (e) { e.preventDefault(); }
    document.getElementById("closeBtn").ontouchmove = function (e) { e.preventDefault(); }
    document.getElementById("exception_clause").ontouchmove = function (e) { e.preventDefault(); }
  }

  closeTip() {
    $("#closeBtn").fadeOut(500);
    $("#shade").fadeOut(500);
    $("#exception_clause").fadeOut(500);
  }

  close() {
    let preUrl = this.commonService.getStorage('dnaReturnUrl');
    if (preUrl) {
      window.location.href = preUrl;
    } else {
      let projectId = localStorage.getItem("projectId")
      let link = ['learning-map'];
      if(projectId){
        link = ['learning-project', projectId]
      }
      this.router.navigate(link);
    }
    this.commonService.removeStorage('dnaReturnUrl');
  }

  closeLayer(i){
    $('#container'+i).removeClass('scaleOut');
    $('#detailReport'+i).removeClass('scaleAll'+i).removeClass('index300').hide();
    $('#exitBtn'+i).hide();
  }

  firstCloseLayer(i){
    $('#normalBallWrap3').find('#container'+i).removeClass('scaleOut');
    $('#normalBallWrap3').find('#detailReport'+i).removeClass('firstScale').removeClass('index300').hide();
    $('#normalBallWrap3').find('#exitBtn'+i).hide();
  }


  /*getMockData(){
    return {
        "id": 2273,
        "survey_id": 3315,
        "emotionality": 15,
        "emotionality_description": "\u5f62\u5bb9\u81ea\u5df1\u7684\u5fc3\u60c5\uff0c\u559c\u6012\u54c0\u4e50\u56db\u4e2a\u5b57\u600e\u4e48\u591f\uff1f\u60c5\u7eea\u4e30\u5bcc\u7684\u4f60\uff0c\u53ef\u80fd\u4e00\u5929\u5c31\u80fd\u7ecf\u5386\u5fc3\u91cc\u7684\u6625\u590f\u79cb\u51ac\u3002<br \/>\u5f88\u591a\u4eba\u773c\u4e2d\uff0c\u4f60\u5f88\u5bb9\u6613\u611f\u5230\u7126\u8651\u548c\u7d27\u5f20\uff0c\u4f46\u8fd9\u5e76\u4e0d\u662f\u4e00\u4ef6\u574f\u4e8b\uff0c\u5f88\u591a\u65f6\u5019\uff0c\u522b\u4eba\u4f1a\u89c9\u5f97\u4f60\u6709\u5f88\u5f3a\u7684\u7d27\u8feb\u611f\u3002\u60f3\u529e\u6cd5\u5c06\u7d27\u5f20\u60c5\u7eea\u8f6c\u5316\u4e3a\u6709\u6548\u884c\u52a8\u5427\uff0c\u4f60\u4f1a\u53d1\u73b0\u5904\u5904\u90fd\u662f\u7f8e\u597d\u7684\u6625\u5929\uff01",
        "delightful": 1,
        "delightful_description": "\u4f60\u5e38\u5e38\u662f\u4e00\u7fa4\u4eba\u5f53\u4e2d\u90a3\u4e2a\u76f4\u8a00\u4e0d\u8bb3\u7684\u803f\u76f4\u6d3e\uff0c\u603b\u662f\u80fd\u7ed9\u522b\u4eba\u7559\u4e0b\u72ec\u7acb\u6709\u4e3b\u89c1\u7684\u5370\u8c61\uff0c\u8ba4\u4e3a\u6b63\u786e\u7684\u4e8b\uff0c\u4f60\u4f1a\u575a\u6301\u5230\u5e95\u3002<br \/>\u89e3\u51b3\u95ee\u9898\u6bd4\u5929\u5927\uff0c\u4ed6\u4eba\u7684\u611f\u53d7\u548c\u60f3\u6cd5\u5728\u95ee\u9898\u9762\u524d\u663e\u5f97\u5fae\u4e0d\u8db3\u9053\uff0c\u8fd9\u6837\u7684\u4f60\u679c\u65ad\u884c\u4e8b\u8ba9\u4eba\u5370\u8c61\u6df1\u523b\u3002\u4e0b\u6b21\u8bd5\u8bd5\u591a\u542c\u542c\u4ed6\u4eba\u610f\u89c1\uff0c\u770b\u770b\u662f\u4e0d\u662f\u66f4\u5bb9\u6613\u83b7\u5f97\u8ba4\u540c\u548c\u4fe1\u670d\u5462\uff1f",
        "extroversion": 11,
        "extroversion_description": "\u987a\u5176\u81ea\u7136\u3001\u4e0e\u4e16\u65e0\u4e89\u7684\u4f5b\u7cfb\u5c11\u5e74\u975e\u4f60\u83ab\u5c5e\u4e86\uff01\u5916\u4eba\u773c\u4e2d\uff0c\u4f60\u4e0d\u5584\u8a00\u8f9e\uff0c\u751a\u81f3\u9762\u5bf9\u964c\u751f\u4eba\u4f1a\u611f\u5230\u7d27\u5f20\uff1b\u4f46\u771f\u6b63\u7684\u670b\u53cb\u77e5\u9053\uff0c\u4f60\u59cb\u7ec8\u5b88\u5019\u5728\u4ed6\u4eec\u8eab\u8fb9\uff0c\u5b89\u9759\u5374\u91cd\u8981\uff01<br \/>\u5de5\u4f5c\u4e2d\uff0c\u5373\u4f7f\u4f5c\u4e3a\u9886\u5bfc\uff0c\u4f60\u4e5f\u613f\u610f\u9ed8\u9ed8\u4ed8\u51fa\u548c\u652f\u6301\u3002\u7ed3\u679c\u56fa\u7136\u91cd\u8981\uff0c\u4f46\u4f60\u4e5f\u540c\u6837\u4eab\u53d7\u8fc7\u7a0b\u3002\u670b\u53cb\u61c2\u4f60\uff0c\u4f46\u56e2\u961f\u4e2d\u7684\u6210\u5458\u4e0d\u4e00\u5b9a\u54e6\uff0c\u591a\u5237\u5b58\u5728\u611f\uff0c\u591a\u591a\u548c\u4ed6\u4eec\u53ca\u65f6\u6c9f\u901a\u5e76\u63d0\u4f9b\u53cd\u9988\uff0c\u624d\u80fd\u8ba9\u56e2\u961f\u6210\u957f\u66f4\u5feb\uff01",
        "responsibility": 2,
        "responsibility_description": "\u89c4\u5219\u662f\u7528\u6765\u6253\u7834\u7684\uff01\u7a81\u53d1\u60c5\u51b5\u4e5f\u80fd\u7075\u6d3b\u5e94\u53d8\u3002\u65e0\u8bba\u751f\u6d3b\u8fd8\u662f\u5de5\u4f5c\uff0c\u4f60\u90fd\u80fd\u4fdd\u6301\u5f00\u653e\u5fc3\u6001\uff0c\u5728\u4f60\u773c\u4e2d\uff0c\u53d8\u5316\u662f\u6311\u6218\u66f4\u662f\u673a\u9047\u3002<br \/>\u4f46\u662f\uff0c\u5e38\u5e38\u4e00\u5f80\u65e0\u524d\u51b2\u51b2\u51b2\u7684\u4f60\u53ef\u80fd\u8981\u5c0f\u5fc3\u5de5\u4f5c\u4e2d\u7684\u51b2\u52a8\u51b3\u7b56\uff0c\u6709\u65f6\u4e5f\u4f1a\u56e0\u4e3a\u5ffd\u7565\u7ec6\u8282\u800c\u5f15\u6765\u9ebb\u70e6\u3002\u8bf7\u6ce8\u610f\u4e09\u601d\u800c\u884c\u54e6\uff01\u4e0d\u601d\uff1f\u4f60\u89c9\u5f97\u884c\u4e0d\u884c\uff1f",
        "open": 64,
        "open_description": "\u4f60\u662f\u670b\u53cb\u5708\u91cc\u7684\u90a3\u4e2a\u6e29\u548c\u6d3e\uff0c\u6709\u65f6\u5bf9\u65b0\u7684\u60f3\u6cd5\u6216\u6539\u53d8\u6301\u6709\u6000\u7591\uff0c\u4f46\u4ecd\u613f\u610f\u70b9\u4e2a\u8d5e\u3002<br \/>\u76f8\u6bd4\u4e8e\u5f00\u8111\u6d1e\uff0c\u4f60\u66f4\u4e50\u4e8e\u4f7f\u7528\u5df2\u6709\u65b9\u6cd5\u89e3\u51b3\u95ee\u9898\u3002<br \/>\u5728\u4e00\u7fa4\u4eba\u4e2d\uff0c\u4f60\u65e2\u4e0d\u662f\u70b9\u5b50\u9891\u9891\uff0c\u4e0d\u5207\u5b9e\u9645\u7684\u90a3\u4e2a\uff0c\u4e5f\u4e0d\u4f1a\u662f\u8fc7\u5206\u82db\u6c42\u7ec6\u8282\uff0c\u6beb\u65e0\u521b\u610f\u7684\u90a3\u4e2a\u3002<br \/>\u4f60\u603b\u662f\u80fd\u638c\u63e1\u60f3\u6cd5\u4e0e\u843d\u5730\u6267\u884c\u7684\u5e73\u8861\uff01",
        "coaching": 0,
        "coaching_description": null,
        "coaching_development": null,
        "guiding": 0,
        "guiding_description": null,
        "guiding_development": null,
        "created_time": "2018-06-07 15:26:08",
        "updated_time": "2018-06-07 15:26:08",
        "delightful_development": "",
        "responsibility_development": "",
        "extroversion_development": "",
        "emotionality_development": "",
        "open_development": "",
        "details": [{
            "id": 489,
            "report_id": 2273,
            "user_id": 355,
            "learning_tour_id": 514,
            "survey_type": 1,
            "ability_id": 1,
            "raw_point": 24,
            "norm_point": 20,
            "level": null,
            "grade": "L",
            "description": "\u4f60\u5e38\u5e38\u662f\u4e00\u7fa4\u4eba\u5f53\u4e2d\u90a3\u4e2a\u76f4\u8a00\u4e0d\u8bb3\u7684\u803f\u76f4\u6d3e\uff0c\u603b\u662f\u80fd\u7ed9\u522b\u4eba\u7559\u4e0b\u72ec\u7acb\u6709\u4e3b\u89c1\u7684\u5370\u8c61\uff0c\u8ba4\u4e3a\u6b63\u786e\u7684\u4e8b\uff0c\u4f60\u4f1a\u575a\u6301\u5230\u5e95\u3002<br \/>\u89e3\u51b3\u95ee\u9898\u6bd4\u5929\u5927\uff0c\u4ed6\u4eba\u7684\u611f\u53d7\u548c\u60f3\u6cd5\u5728\u95ee\u9898\u9762\u524d\u663e\u5f97\u5fae\u4e0d\u8db3\u9053\uff0c\u8fd9\u6837\u7684\u4f60\u679c\u65ad\u884c\u4e8b\u8ba9\u4eba\u5370\u8c61\u6df1\u523b\u3002\u4e0b\u6b21\u8bd5\u8bd5\u591a\u542c\u542c\u4ed6\u4eba\u610f\u89c1\uff0c\u770b\u770b\u662f\u4e0d\u662f\u66f4\u5bb9\u6613\u83b7\u5f97\u8ba4\u540c\u548c\u4fe1\u670d\u5462\uff1f",
            "development": "",
            "created_time": "2018-06-07 15:26:08",
            "updated_time": "2018-06-07 15:26:08",
            "name": "\u5b9c\u4eba",
            "explanation": "\u613f\u610f\u5173\u5fc3\u5e76\u7406\u89e3\u4ed6\u4eba\u611f\u53d7\u7684\u503e\u5411\u3002",
            "low_level_explanation": "low",
            "high_level_explanation": "high"
        }, {
            "id": 490,
            "report_id": 2273,
            "user_id": 355,
            "learning_tour_id": 514,
            "survey_type": 1,
            "ability_id": 2,
            "raw_point": 28,
            "norm_point": 27,
            "level": null,
            "grade": "L",
            "description": "\u89c4\u5219\u662f\u7528\u6765\u6253\u7834\u7684\uff01\u7a81\u53d1\u60c5\u51b5\u4e5f\u80fd\u7075\u6d3b\u5e94\u53d8\u3002\u65e0\u8bba\u751f\u6d3b\u8fd8\u662f\u5de5\u4f5c\uff0c\u4f60\u90fd\u80fd\u4fdd\u6301\u5f00\u653e\u5fc3\u6001\uff0c\u5728\u4f60\u773c\u4e2d\uff0c\u53d8\u5316\u662f\u6311\u6218\u66f4\u662f\u673a\u9047\u3002<br \/>\u4f46\u662f\uff0c\u5e38\u5e38\u4e00\u5f80\u65e0\u524d\u51b2\u51b2\u51b2\u7684\u4f60\u53ef\u80fd\u8981\u5c0f\u5fc3\u5de5\u4f5c\u4e2d\u7684\u51b2\u52a8\u51b3\u7b56\uff0c\u6709\u65f6\u4e5f\u4f1a\u56e0\u4e3a\u5ffd\u7565\u7ec6\u8282\u800c\u5f15\u6765\u9ebb\u70e6\u3002\u8bf7\u6ce8\u610f\u4e09\u601d\u800c\u884c\u54e6\uff01\u4e0d\u601d\uff1f\u4f60\u89c9\u5f97\u884c\u4e0d\u884c\uff1f",
            "development": "",
            "created_time": "2018-06-07 15:26:08",
            "updated_time": "2018-06-07 15:26:08",
            "name": "\u8c28\u614e",
            "explanation": "\u613f\u610f\u9075\u5b88\u89c4\u8303\uff0c\u4e3a\u8fbe\u6210\u76ee\u6807\u800c\u52aa\u529b\u7684\u7a0b\u5ea6\u3002",
            "low_level_explanation": "low",
            "high_level_explanation": "high"
        }, {
            "id": 491,
            "report_id": 2273,
            "user_id": 355,
            "learning_tour_id": 514,
            "survey_type": 1,
            "ability_id": 3,
            "raw_point": 38,
            "norm_point": 84,
            "level": null,
            "grade": "L",
            "description": "\u987a\u5176\u81ea\u7136\u3001\u4e0e\u4e16\u65e0\u4e89\u7684\u4f5b\u7cfb\u5c11\u5e74\u975e\u4f60\u83ab\u5c5e\u4e86\uff01\u5916\u4eba\u773c\u4e2d\uff0c\u4f60\u4e0d\u5584\u8a00\u8f9e\uff0c\u751a\u81f3\u9762\u5bf9\u964c\u751f\u4eba\u4f1a\u611f\u5230\u7d27\u5f20\uff1b\u4f46\u771f\u6b63\u7684\u670b\u53cb\u77e5\u9053\uff0c\u4f60\u59cb\u7ec8\u5b88\u5019\u5728\u4ed6\u4eec\u8eab\u8fb9\uff0c\u5b89\u9759\u5374\u91cd\u8981\uff01<br \/>\u5de5\u4f5c\u4e2d\uff0c\u5373\u4f7f\u4f5c\u4e3a\u9886\u5bfc\uff0c\u4f60\u4e5f\u613f\u610f\u9ed8\u9ed8\u4ed8\u51fa\u548c\u652f\u6301\u3002\u7ed3\u679c\u56fa\u7136\u91cd\u8981\uff0c\u4f46\u4f60\u4e5f\u540c\u6837\u4eab\u53d7\u8fc7\u7a0b\u3002\u670b\u53cb\u61c2\u4f60\uff0c\u4f46\u56e2\u961f\u4e2d\u7684\u6210\u5458\u4e0d\u4e00\u5b9a\u54e6\uff0c\u591a\u5237\u5b58\u5728\u611f\uff0c\u591a\u591a\u548c\u4ed6\u4eec\u53ca\u65f6\u6c9f\u901a\u5e76\u63d0\u4f9b\u53cd\u9988\uff0c\u624d\u80fd\u8ba9\u56e2\u961f\u6210\u957f\u66f4\u5feb\uff01",
            "development": "",
            "created_time": "2018-06-07 15:26:08",
            "updated_time": "2018-06-07 15:26:08",
            "name": "\u793e\u4ea4",
            "explanation": "\u5bf9\u4eba\u9645\u4e92\u52a8\u548c\u793e\u4f1a\u8ba4\u540c\u7684\u9700\u6c42\u7a0b\u5ea6\u3002",
            "low_level_explanation": "low",
            "high_level_explanation": "high"
        }, {
            "id": 492,
            "report_id": 2273,
            "user_id": 355,
            "learning_tour_id": 514,
            "survey_type": 1,
            "ability_id": 4,
            "raw_point": 24,
            "norm_point": 65,
            "level": null,
            "grade": "L",
            "description": "\u5f62\u5bb9\u81ea\u5df1\u7684\u5fc3\u60c5\uff0c\u559c\u6012\u54c0\u4e50\u56db\u4e2a\u5b57\u600e\u4e48\u591f\uff1f\u60c5\u7eea\u4e30\u5bcc\u7684\u4f60\uff0c\u53ef\u80fd\u4e00\u5929\u5c31\u80fd\u7ecf\u5386\u5fc3\u91cc\u7684\u6625\u590f\u79cb\u51ac\u3002<br \/>\u5f88\u591a\u4eba\u773c\u4e2d\uff0c\u4f60\u5f88\u5bb9\u6613\u611f\u5230\u7126\u8651\u548c\u7d27\u5f20\uff0c\u4f46\u8fd9\u5e76\u4e0d\u662f\u4e00\u4ef6\u574f\u4e8b\uff0c\u5f88\u591a\u65f6\u5019\uff0c\u522b\u4eba\u4f1a\u89c9\u5f97\u4f60\u6709\u5f88\u5f3a\u7684\u7d27\u8feb\u611f\u3002\u60f3\u529e\u6cd5\u5c06\u7d27\u5f20\u60c5\u7eea\u8f6c\u5316\u4e3a\u6709\u6548\u884c\u52a8\u5427\uff0c\u4f60\u4f1a\u53d1\u73b0\u5904\u5904\u90fd\u662f\u7f8e\u597d\u7684\u6625\u5929\uff01",
            "development": "",
            "created_time": "2018-06-07 15:26:08",
            "updated_time": "2018-06-07 15:26:08",
            "name": "\u60c5\u7eea\u7a33\u5b9a",
            "explanation": "\u5bf9\u60c5\u7eea\u7684\u4f53\u9a8c\u548c\u60c5\u611f\u8c03\u8282\u7684\u6c34\u5e73\u3002",
            "low_level_explanation": "low",
            "high_level_explanation": "high"
        }, {
            "id": 493,
            "report_id": 2273,
            "user_id": 355,
            "learning_tour_id": 514,
            "survey_type": 1,
            "ability_id": 5,
            "raw_point": 51,
            "norm_point": 14,
            "level": null,
            "grade": "M",
            "description": "\u4f60\u662f\u670b\u53cb\u5708\u91cc\u7684\u90a3\u4e2a\u6e29\u548c\u6d3e\uff0c\u6709\u65f6\u5bf9\u65b0\u7684\u60f3\u6cd5\u6216\u6539\u53d8\u6301\u6709\u6000\u7591\uff0c\u4f46\u4ecd\u613f\u610f\u70b9\u4e2a\u8d5e\u3002<br \/>\u76f8\u6bd4\u4e8e\u5f00\u8111\u6d1e\uff0c\u4f60\u66f4\u4e50\u4e8e\u4f7f\u7528\u5df2\u6709\u65b9\u6cd5\u89e3\u51b3\u95ee\u9898\u3002<br \/>\u5728\u4e00\u7fa4\u4eba\u4e2d\uff0c\u4f60\u65e2\u4e0d\u662f\u70b9\u5b50\u9891\u9891\uff0c\u4e0d\u5207\u5b9e\u9645\u7684\u90a3\u4e2a\uff0c\u4e5f\u4e0d\u4f1a\u662f\u8fc7\u5206\u82db\u6c42\u7ec6\u8282\uff0c\u6beb\u65e0\u521b\u610f\u7684\u90a3\u4e2a\u3002<br \/>\u4f60\u603b\u662f\u80fd\u638c\u63e1\u60f3\u6cd5\u4e0e\u843d\u5730\u6267\u884c\u7684\u5e73\u8861\uff01",
            "development": "",
            "created_time": "2018-06-07 15:26:08",
            "updated_time": "2018-06-07 15:26:08",
            "name": "\u5f00\u653e",
            "explanation": "\u613f\u610f\u63a5\u53d7\u65b0\u4e8b\u7269\u3001\u65b0\u89c2\u5ff5\u548c\u65b0\u523a\u6fc0\u7684\u7a0b\u5ea6\u3002",
            "low_level_explanation": "文案文案文案文案文案文案文案文案文案文案文案文案文案文案",
            "high_level_explanation": "high"
        }]
    }
  }*/
}



// WEBPACK FOOTER //
// ./src/app/report/report.component.ts